import React from 'react'
import { useParams } from 'react-router'
import { components } from 'cng-web-lib'

import FormProperties from './CiaCountry_FormProperties'
import CIACountryApiUrls from 'src/apiUrls/CIACountryApiUrls'

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification}) {
    
    const { id } = useParams()

    return (
        <CngEditForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            history={history}
            showNotification={showNotification}
            bodySection={
                <FormProperties.Fields
                    disabled={true}
                    isEditable={true}
                    showNotification={showNotification}
                    id={id}
                />
            }
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            fetch={{ url: CIACountryApiUrls.GET }}
            update={{ url: CIACountryApiUrls.PUT }}
            id={id}
        />
    )
}

export default EditPage